/*=========================================================================================
  File Name: authFirstScreenActions.js
  Description: Vuex Store - first auth screen actions
==========================================================================================*/

export default {

    /**
     * get first screen after authorizing
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    fetchFirstAuthAdminScreen({commit}, payload) {
        if (state.sidebarMenuAdmin.length === 0) {
            commit('fetch_first_auth_admin_screen');
            return new Promise((resolve, reject) => {
                axios.all([
                    axios({url: state.API_URL + '/auth/user', method: 'GET'}),
                    axios({url: state.API_URL + '/auth/settings/' + state.user_id, method: 'GET'}),
                    axios({url: state.API_URL + '/auth/active-languages', method: 'GET'}),
                    axios({url: state.API_URL + '/auth/countries', method: 'GET'})
                ]).then(axios.spread((user, settings, languages, countries) => {
                    if (user.data.activeLanguage.id !== parseInt(state.local_active_language_id)) {
                        const lang_payload = {
                            active_language_id: state.local_active_language_id,
                        };
                                axios.all([
                                    axios({url: state.API_URL + '/auth/user', method: 'GET'}),
                                    axios({url: state.API_URL + '/auth/current-translations', method: 'GET'}),
                                    axios({url: state.API_URL + '/auth/backend-menus', method: 'GET'}),
                                ]).then(axios.spread((
                                    new_user_data,
                                    translations,
                                    menu
                                ) => {
                                    let data = {
                                        basicOrganizationData: settings.data.basicOrganizationData,
                                        organization_name: settings.data.basicOrganizationData.name,
                                        activeLanguage: new_user_data.data.activeLanguage,
                                        themeSettings: settings.data.themeSettings,
                                        currentTranslations: translations.data.currentTranslations,
                                        user: new_user_data.data.user,
                                        profile: new_user_data.data.profile,
                                        notification_settings: new_user_data.data.notification_settings,
                                        profileImage: new_user_data.data.profileImage,
                                        profileImage_b: new_user_data.data.profileImage_b,
                                        profileImage_s: new_user_data.data.profileImage_s,
                                        coverImage: new_user_data.data.coverImage,
                                        coverImage_b: new_user_data.data.coverImage_b,
                                        coverImage_m: new_user_data.data.coverImage_m,
                                        coverImage_s: new_user_data.data.coverImage_s,
                                        menus: {
                                            languageMenu: languages.data,
                                            sidebarMenuAdminName: menu.data.sidebarMenuAdminName,
                                            sidebarMenuAdmin: menu.data.sidebarMenuAdmin,
                                            profileMenu: menu.data.profileMenu,
                                        },
                                        searchable: menu.data.searchable,
                                        staredPages: menu.data.staredPages,
                                        countries: countries.data,
                                    };

                                    if (payload.message !== false) {
                                        payload.notify({
                                            time: 3500,
                                            text: state.currentTranslations[payload.message],
                                            iconPack: 'feather',
                                            icon: 'icon-check',
                                            color: 'success'
                                        });
                                    }

                                    localStorage.setItem('primary_color', data.themeSettings !== null ? data.themeSettings.primary_color : state.defaultTheme.primary_color);

                                    commit('first_auth_admin_screen_fetched', data);
                                    resolve();
                                })).catch(() => {
                                    commit('fetch_first_auth_admin_screen_error');
                                    localStorage.removeItem('access-token');
                                    delete axios.defaults.headers.common['Authorization'];
                                    reject();
                                });
                    } else {
                        axios.all([
                            axios({url: state.API_URL + '/auth/current-translations', method: 'GET'}),
                            axios({url: state.API_URL + '/auth/backend-menus', method: 'GET'}),
                        ]).then(axios.spread((
                            translations,
                            menu
                        ) => {
                            let data = {
                                basicOrganizationData: settings.data.basicOrganizationData,
                                organization_name: settings.data.basicOrganizationData.name,
                                activeLanguage: user.data.activeLanguage,
                                themeSettings: settings.data.themeSettings,
                                currentTranslations: translations.data.currentTranslations,
                                user: user.data.user,
                                profile: user.data.profile,
                                notification_settings: user.data.notification_settings,
                                profileImage: user.data.profileImage,
                                profileImage_b: user.data.profileImage_b,
                                profileImage_s: user.data.profileImage_s,
                                coverImage: user.data.coverImage,
                                coverImage_b: user.data.coverImage_b,
                                coverImage_m: user.data.coverImage_m,
                                coverImage_s: user.data.coverImage_s,
                                menus: {
                                    languageMenu: languages.data,
                                    sidebarMenuAdminName: menu.data.sidebarMenuAdminName,
                                    sidebarMenuAdmin: menu.data.sidebarMenuAdmin,
                                    profileMenu: menu.data.profileMenu,
                                },
                                searchable: menu.data.searchable,
                                staredPages: menu.data.staredPages,
                                countries: countries.data,
                            };

                            if (payload.message !== false) {
                                payload.notify({
                                    time: 3500,
                                    text: state.currentTranslations[payload.message],
                                    iconPack: 'feather',
                                    icon: 'icon-check',
                                    color: 'success'
                                });
                            }

                            localStorage.setItem('primary_color', data.themeSettings !== null ? data.themeSettings.primary_color : state.defaultTheme.primary_color);

                            commit('first_auth_admin_screen_fetched', data);
                            resolve();
                        })).catch(() => {
                            commit('fetch_first_auth_admin_screen_error');
                            localStorage.removeItem('access-token');
                            delete axios.defaults.headers.common['Authorization'];
                            reject();
                        });
                    }
                })).catch(() => {
                    commit('fetch_first_auth_admin_screen_error');
                    localStorage.removeItem('access-token');
                    delete axios.defaults.headers.common['Authorization'];
                    reject();
                });
            })
        }
    },

    /**
     * change active user languag   e
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    change_active_user_language({commit}, payload) {
        return new Promise((resolve) => {
            commit('change_active_user_language');
                    axios.all([
                        axios({url: state.API_URL + '/auth/user', method: 'GET'}),
                        axios({url: state.API_URL + '/auth/backend-menus', method: 'GET'}),
                        axios({url: state.API_URL + '/auth/current-translations', method: 'GET'}),
                    ]).then(axios.spread((
                        user,
                        menu,
                        translations
                    ) => {
                        let user_menu_data = {
                            activeLanguage: user.data.activeLanguage,
                            currentTranslations: translations.data.currentTranslations,
                            menus: {
                                sidebarMenuAdminName: menu.data.sidebarMenuAdminName,
                                sidebarMenuAdmin: menu.data.sidebarMenuAdmin,
                                profileMenu: menu.data.profileMenu,
                            },
                            searchable: menu.data.searchable,
                            staredPages: menu.data.staredPages,
                        };

                        commit('active_user_language_changed', user_menu_data);

                        payload.notify({
                            time: 3500,
                            text: state.currentTranslations['pages.languages.messages.success.active_changed'],
                            iconPack: 'feather',
                            icon: 'icon-check',
                            color: 'success'
                        });

                        resolve();
                    }));
        })
    },

    /**
     * Logout
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    logout({commit}, payload) {
        return new Promise((resolve) => {
            commit('logout');
            axios({url: state.API_URL + '/auth/logout', method: 'GET'})
                .then(({data}) => {
                    commit('logout_success');
                    localStorage.removeItem('access-token');
                    delete axios.defaults.headers.common['Authorization'];

                    // Close animation if passed as payload
                    if (payload != null) {
                        payload.notify({
                            time: 2500,
                            text: state.currentTranslations[data.message],
                            iconPack: 'feather',
                            icon: 'icon-check',
                            color: 'success'
                        });
                    }

                    resolve(data);
                });
        })
    },
};
import axios from "axios";
import state from "../state";
